import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-oop-svg',
  imports: [],
  templateUrl: './oop-svg.component.html',
  styleUrl: './oop-svg.component.css'
})
export class OopSvgComponent {
  @Input() width: string = '50'
  @Input() height: string = '50'
}
